import React from 'react';
import styles from './Input.module.scss';

type Props = {
  value: string;
  onChange?: (val: string) => void;
  onFocus?: () => void;
  onBlur?: () => void;
  placeholder?: string;
  space?: boolean;
}

const Input: React.FC<Props> = ({
  value,
  onChange = () => {},
  onFocus = () => {},
  onBlur = () => {},
  placeholder = '',
  space = true,
}) => (
  <div className={`${styles.inputBox} ${space ? styles.space : ''}`}>
    <input
      className={styles.input}
      type="text"
      value={value}
      onChange={(e) => onChange(e.target.value)}
      placeholder={placeholder}
      onFocus={onFocus}
      onBlur={onBlur}
    />
  </div>
);

export default Input;
